import { useState } from "react";
import { ProductWithRelations, VariantSelection } from "Types";
import { ProductVariant, ProductVariantOption } from ".prisma/client";
import createRandomKey from "helpers/createRandomKey";
import { useCartContext } from "context/CartContext";
import { getProductTotalPrice } from "helpers/cartHelpers";
import { getTranslation } from "dictionary";
import { toast } from "react-toastify";
import { useUserContext } from "context/UserContext";

export const useProduct = (product: ProductWithRelations, features: string) => {
  const { dispatch } = useCartContext();
  const { language } = useUserContext();
  const [count, setCount] = useState(1);

  const notify = () => {
    toast.success(getTranslation("menu", "ADDED_TO_CART", language));
  };

  const [variantSelection, setVariantSelection] = useState<VariantSelection>(
    () =>
      product.variants?.reduce((acc: { [key: string]: string }, v) => {
        if (v.isRequired) {
          acc[v.id] = v.options[0].id;
        } else {
          acc[v.id] = "";
        }
        return acc;
      }, {})
  );

  const totalPrice = getProductTotalPrice({
    product,
    count,
    variantSelection,
  });

  const changeCount = (action: "INCREMENT" | "DECREMENT") => {
    const incrementCount = () => {
      setCount((prev) => prev + 1);
    };
    const decrementCount = () => {
      if (count === 1) {
        return;
      }
      setCount((prev) => prev - 1);
    };
    if (action === "INCREMENT") incrementCount();
    else decrementCount();
  };

  const handleOptionSelection = (
    variant: ProductVariant,
    option: ProductVariantOption
  ) => {
    if (features === "CATALOGO") return;
    setVariantSelection((prev) => {
      if (!variant.isRequired && prev[variant.id] === option.id) {
        return {
          ...prev,
          [variant.id]: "",
        };
      } else
        return {
          ...prev,
          [variant.id]: option.id,
        };
    });
  };

  const handleAddToCart = () => {
    // @ts-ignore
    dispatch({
      type: "add_to_cart",
      payload: {
        itemId: createRandomKey(),
        product,
        count,
        variantSelection,
      },
    });
    notify();
  };

  return {
    variantSelection,
    totalPrice,
    handleOptionSelection,
    handleAddToCart,
    count,
    changeCount,
  };
};
